/* Every long-form guide, by address. publishingRenderers.test.js keeps this
   in step with publishingContent.json, which the app does not load up front. */
export const GUIDE_SLUGS = [
  'ai-second-brain',
  'second-brain-app',
  'ai-note-taking-workflow',
  'personal-knowledge-management-ai',
  'most-note-apps-solve-capture-not-recall',
  'readwise-is-not-a-second-brain',
  'highlights-into-concepts',
  'ai-reading-without-losing-judgment',
  'best-second-brain-app-for-founders',
  'best-second-brain-app-for-researchers',
  'source-backed-synthesis-workflow',
  'import-reading-archive-into-noeis',
  'from-saved-article-to-draft-in-noeis',
  'build-a-wiki-from-your-reading',
  'connect-ai-agent-to-your-reading-mcp',
  'ai-answers-quoted-from-your-sources'
];
